import { Gender } from './Gender';
import { Serializable } from '../utilities/Serializable';
import { CurrentAccount } from './CurrentAccount';

export class Customer extends Serializable {
  uuid: string;
  firstName: string;
  lastName: string;
  telephoneNumber: string;
  email: string;
  dateOfBirth: string;
  address: string;
  city: string;
  province: string;
  cap: string;
  country: string;
  //enabled: boolean;

  gender: Gender;

  currentAccounts: CurrentAccount[];

  constructor() {
    super();

    this.gender = Gender.not_specified;
    this.currentAccounts = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Customer.ts